const Dept = () => import(/* webpackChunkName: "syst" */ './dept/Index');
const Role = () => import(/* webpackChunkName: "syst" */ './role/Index');
const User = () => import(/* webpackChunkName: "syst" */ './user/Index');
const Api = () => import(/* webpackChunkName: "syst" */ './api/Index');
const Menu = () => import(/* webpackChunkName: "syst" */ './menu/Index');
const Func = () => import(/* webpackChunkName: "syst" */ './func/Index');
const Log = () => import(/* webpackChunkName: "syst" */ './log/Index');

export default {
  routes: [
    {
      path: '/syst/dept',
      name: 'syst_dept',
      component: Dept
    }, {
      path: '/syst/role',
      name: 'syst_role',
      component: Role
    }, {
      path: '/syst/user',
      name: 'syst_user',
      component: User
    }, {
      path: '/syst/api',
      name: 'syst_api',
      component: Api
    }, {
      path: '/syst/menu',
      name: 'syst_menu',
      component: Menu
    }, {
      path: '/syst/func',
      name: 'syst_func',
      component: Func
    }, {
      path: '/syst/log',
      name: 'syst_log',
      component: Log
    }
  ]
}
